// Thin site-wide availability bar. Dismissible; state persists in
// localStorage. Never fake urgency: reflects a real capacity policy.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const DISMISS_KEY = "kostaja_avail_bar_dismissed_v1";

const AnnouncementBar = () => {
  const [hidden, setHidden] = useState(true);
  useEffect(() => {
    try {
      setHidden(localStorage.getItem(DISMISS_KEY) === "1");
    } catch (err) {
      // Private mode or storage blocked. Fail open so the bar still renders.
      if (typeof console !== "undefined") console.debug("availability bar: storage read blocked", err);
      setHidden(false);
    }
  }, []);
  if (hidden) return null;
  return (
    <div
      data-testid="availability-bar"
      className="relative z-50 bg-[#FFC600] text-black border-b border-black/10"
    >
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10 h-9 flex items-center justify-between gap-4">
        <Link
          to="/waitlist"
          data-testid="availability-bar-link"
          className="flex-1 flex items-center justify-center lg:justify-start gap-3 text-[10px] lg:text-[11px] uppercase tracking-[0.22em] font-black hover:opacity-80 transition-opacity"
        >
          <span>2026 project capacity is allocated</span>
          <span aria-hidden className="opacity-50">·</span>
          <span className="underline underline-offset-[3px] decoration-2">2027 applications open →</span>
        </Link>
        <button
          type="button"
          aria-label="Dismiss availability notice"
          data-testid="availability-bar-dismiss"
          onClick={() => {
            try {
              localStorage.setItem(DISMISS_KEY, "1");
            } catch (err) {
              // Storage blocked. Dismissal will not persist across reloads, but
              // the current session still hides the bar via setHidden below.
              if (typeof console !== "undefined") console.debug("availability bar: storage write blocked", err);
            }
            setHidden(true);
          }}
          className="shrink-0 inline-flex items-center justify-center w-7 h-7 text-black/70 hover:text-black"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBar;
